import { call } from 'redux-saga/effects';

import { branch } from '../../../sagas/Helpers';

import * as UpgradeHelpers from './helpers';

export function* upgrade({ payload: { tierSlug, subTierSlug } }) {
  yield call(
    branch(
      UpgradeHelpers.isAuthenticatedListener,
      UpgradeHelpers.authenticatedUpgrade,
      UpgradeHelpers.unauthenticatedUpgrade,
    ),
    tierSlug,
    subTierSlug,
  );
}
